import {sitemap} from './sitemap.js'
// const sitemap = {sites: []}

export const SiteMapRenderer = () => {
  return (
    <div>
      <h2>All Documentation</h2>
      <ul>
      {sitemap.sites
      .sort((a,b)=> {
        if(a.title < b.title) {
          return -1
        }
        if(a.title > b.title) {
          return 1
        }
        return 0
      })
      .map((value) => <SiteMapItem item={value} />)}
      </ul>
    </div>
  )
}

export const SiteMapItem = ({item}) => {
  return (
    <li>
      <a style={{color: 'var(--theme-ui-colors-primary,#1FB6FF)', textDecoration: 'none'}} href={item.path}>
        {item.title.replace(' | Young Living Common Docs', '')}
        </a>
    </li>
  )
}
